<template>
    <button @click.prevent="setDarkMode(!darkMode)"
            type="button"
            :class="buttonClass"
            class="border p-2 rounded-lg focus:outline-none transition">
        <icon name="sun" class="h-5 w-5" v-show="darkMode"/>
        <icon name="moon" class="h-5 w-5" v-show="!darkMode"/>
    </button>
</template>

<script>
export default {
    name: 'DarkModeToggle',

    props: {
        light: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            darkMode: false,
        };
    },

    computed: {
        buttonClass() {
            if (this.light) {
                return 'text-gray-400 border-gray-300 hover:bg-gray-300 hover:text-gray-600 dark:text-gray-600 dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-gray-400';
            }
            return 'text-gray-600 border-gray-600 hover:bg-gray-600 hover:text-gray-400';
        },
    },

    mounted() {
        this.darkMode = localStorage.theme === 'dark' ||
            (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches);
        this.setDarkMode(this.darkMode);
    },

    methods: {
        setDarkMode(dark) {
            if (dark) {
                localStorage.theme = 'dark';
                document.querySelector('html').classList.add('dark');
                this.darkMode = true;
            } else {
                localStorage.theme = 'light';
                document.querySelector('html').classList.remove('dark');
                this.darkMode = false;
            }
        },
    },
};
</script>
